import { GlIcon } from '/builds/gitlab/gitlab-ee/node_modules/@gitlab/ui/src/index.js?vue3';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import { findWorkplanWidget } from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/work_items/utils.js?vue3';
import workItemAgentPlanQuery from 'ee/work_items/graphql/work_item_agent_plan.query.graphql';
import { GENERATION_STATUS_NEEDS_INPUT } from './constants';
import { getAwaitingInputLabel } from './utils';
import WorkplanQuestionNavigator from '/builds/gitlab/gitlab-ee/ee/app/assets/javascripts/work_items/components/implementation_widget/workplan_question_navigator.vue?vue3';
export default {
    name: 'WorkplanStickyHeaderQuestions',
    components: {
        GlIcon,
        WorkplanQuestionNavigator
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    props: {
        workItemId: {
            type: String,
            required: true
        }
    },
    data () {
        return {
            workplan: null
        };
    },
    apollo: {
        // Reads the plan the Workplan widget fetches and keeps fresh, so its variables have to
        // match the widget's, or this reads nothing.
        workplan: {
            query: workItemAgentPlanQuery,
            fetchPolicy: 'cache-only',
            variables () {
                return {
                    id: this.workItemId,
                    useWorkItemFeatures: Boolean(this.glFeatures?.workItemFeaturesField),
                    includeReadinessScore: Boolean(this.glFeatures?.workplanScore)
                };
            },
            update (data) {
                return findWorkplanWidget(data?.workItem) || null;
            }
        }
    },
    computed: {
        openQuestionsCount () {
            return this.workplan?.openQuestionsCount ?? 0;
        },
        showQuestions () {
            return this.workplan?.generationStatus === GENERATION_STATUS_NEEDS_INPUT && this.openQuestionsCount > 0;
        },
        awaitingInputLabel () {
            return getAwaitingInputLabel(this.openQuestionsCount);
        }
    }
};
